import ApiService from '../../../../../services/ApiService'
import ManageMeasurement from '../ManageMeasurement/ManageMeasurement.vue'

export default {
  props: {
    parametersProps: Array,
    serviceOrderId: Number,
  },

  components: {
    ManageMeasurement,
  },

  async created() {
    this.parameters = this.parametersProps.map((x) => {
      if (x.calibrationPatternTemplateParametersMetricsRanges) {
        x.calibrationPatternTemplateParametersMetricsRanges.sort(function (
          a,
          b
        ) {
          if (
            a.calibrationPatternMetricsRange.range >
            b.calibrationPatternMetricsRange.range
          ) {
            return -1
          } else {
            return true
          }
        })
      }
      return x
    })

    await this.getCalibrationMetrics()
    await this.getCalibrationPatterns()
  },

  data: () => ({
    loading: false,
    newMeasurementDialog: false,
    dialogKey: false,
    rangeNewId: null,
    calibrationPatternMetricsId: null,
    expanded: [],
    parameters: [],
    calibrationMetrics: [],
    calibrationPatterns: [],
    calibrationTemplateParameters: [],
    calibrationParameterMetricRange: {
      CalibrationPatternMetricsRangeId: null,
      CalibrationPatternTemplateParameterId: null,
      ValueOne: null,
      ValueTwo: null,
      ValueThree: null,
      ValueFour: null,
      ValueFive: null,
    },
    calibrationParameterMetricRanges: [],
    parameterRanges: [],
    measurementModel: {},
    alias: null,
    resolution: null,
    headers: [
      {
        text: 'Métrica',
        align: 'center',

        value: 'metric',
        width: 60,
        sortable: false,
      },
      {
        text: 'Padrão',
        align: 'center',

        value: 'pattern',
        width: 60,
        sortable: false,
      },
      {
        text: 'Alias Param.',
        align: 'center',

        value: 'alias',
        width: 60,
        sortable: false,
      },
      {
        text: 'Unid.',
        align: 'center',

        value: 'unit',
        sortable: false,
        width: 60,
      },
      {
        text: 'Res.',
        align: 'center',

        value: 'resolution',
        sortable: false,
        width: 60,
      },
      {
        text: 'K',
        align: 'center',

        value: 'k',
        sortable: false,
        width: 60,
      },
      {
        text: 'Incerteza',
        align: 'center',

        value: 'uncertainty',
        sortable: false,
        width: 60,
      },
      {
        text: 'Tendência',
        align: 'center',

        value: 'tendency',
        sortable: false,
        width: 60,
      },
      {
        text: 'Faixa',
        align: 'center',

        value: 'range',
        sortable: false,
        width: 60,
      },
      {
        text: 'VL1',
        align: 'center',

        value: 'valueOne',
        width: 100,
        sortable: false,
      },
      {
        text: 'VL2',
        align: 'center',

        value: 'valueTwo',
        width: 100,
        sortable: false,
      },
      {
        text: 'VL3',
        align: 'center',

        value: 'valueThree',
        width: 100,
        sortable: false,
      },
      {
        text: 'VL4',
        align: 'center',

        value: 'valueFour',
        width: 100,
        sortable: false,
      },
      {
        text: 'VL5',
        align: 'center',

        value: 'valueFive',
        width: 100,
        sortable: false,
      },
      {
        align: 'center',

        value: 'action',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Métrica',
        align: 'center',

        value: 'metric',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
  }),

  methods: {
    closeDialog() {
      this.newMeasurementDialog = false
      this.dialogKey = !this.dialogKey
    },

    newMeasurement(item, parameter) {
      const templateParameters = this.calibrationTemplateParameters.find(
        (x) => x.CalibrationPatternTemplateParameterId === parameter.id
      )
      if (templateParameters) {
        const resolutionEquipment = templateParameters.ResolutionEquipment
        this.measurementModel = {
          CalibrationPatternTemplateParametersMetricsRanges: item,
          ResolutionEquipment: resolutionEquipment,
          CalibrationPatternId: parameter.calibrationPatternId,
          Parameter: parameter,
        }
        this.parameterRanges =
          parameter.calibrationPatternTemplateParametersMetricsRanges
        this.dialogKey = !this.dialogKey
        this.newMeasurementDialog = true
      } else {
        this.$toast.error('Favor inserir a resolução do equipamento')
      }
    },

    addNewRange(newRange) {
      if (newRange) {
        const parameter = this.parameters.find(
          (x) => x.id === newRange.range.CalibrationPatternTemplateParameter.id
        )

        const metricRange = {
          id: newRange.range.CalibrationPatternMetricRange.Id,
          range: newRange.range.CalibrationPatternMetricRange.Range,
          k: newRange.range.CalibrationPatternMetricRange.K,
          uncertainty: newRange.range.CalibrationPatternMetricRange.Uncertainty,
          tendency: newRange.range.CalibrationPatternMetricRange.Tendency,
          calibrationPatternMetricsId:
            newRange.range.CalibrationPatternMetricRange
              .CalibrationPatternMetricsId,
          calibrationPatternMetrics: newRange.range.CalibrationPatternMetric,
          valueOne: newRange.range.ValueOne,
          valueTwo: newRange.range.ValueTwo,
          valueThree: newRange.range.ValueThree,
          valueFour: newRange.range.ValueFour,
          valueFive: newRange.range.ValueFive,
        }
        const calibrationPatternTemplateParametersMetricsRange = {
          calibrationPatternMetricsRange: metricRange,
          calibrationPatternMetricsRangeId: metricRange.id,
          calibrationPatternTemplateParametersId:
            newRange.range.CalibrationPatternTemplateParameter.Id,
        }

        parameter.calibrationPatternTemplateParametersMetricsRanges.push(
          calibrationPatternTemplateParametersMetricsRange
        )

        this.setValueOne(newRange.range.ValueOne, metricRange.id, parameter.id)
        this.setValueTwo(newRange.range.ValueTwo, metricRange.id, parameter.id)
        this.setValueThree(
          newRange.range.ValueThree,
          metricRange.id,
          parameter.id
        )
        this.setValueFour(
          newRange.range.ValueFour,
          metricRange.id,
          parameter.id
        )
        this.setValueFive(
          newRange.range.ValueFive,
          metricRange.id,
          parameter.id
        )
      }
    },

    setResolutionEquipment(value, parameterId) {
      const calibrationTemplateParameter = {
        CalibrationPatternTemplateParameterId: parameterId,
        ResolutionEquipment: value,
      }
      this.calibrationTemplateParameters.push(calibrationTemplateParameter)
    },

    setValueOne(value, rangeId, parameterId) {
      const calibrationParameterMetricRange = {
        CalibrationPatternMetricsRangeId: rangeId,
        CalibrationPatternTemplateParameterId: parameterId,
        ValueOne: value,
      }

      const parameterMetricRange = this.calibrationParameterMetricRanges.find(
        (x) =>
          x.CalibrationPatternMetricsRangeId === rangeId &&
          x.CalibrationPatternTemplateParameterId === parameterId
      )

      if (parameterMetricRange) {
        parameterMetricRange.ValueOne = value
        return
      } else {
        this.calibrationParameterMetricRanges = [
          ...this.calibrationParameterMetricRanges,
          calibrationParameterMetricRange,
        ]
      }
    },

    setValueTwo(value, rangeId, parameterId) {
      const calibrationParameterMetricRange = {
        CalibrationPatternMetricsRangeId: rangeId,
        CalibrationPatternTemplateParameterId: parameterId,
        ValueTwo: value,
      }

      const parameterMetricRange = this.calibrationParameterMetricRanges.find(
        (x) =>
          x.CalibrationPatternMetricsRangeId === rangeId &&
          x.CalibrationPatternTemplateParameterId === parameterId
      )

      if (parameterMetricRange) {
        parameterMetricRange.ValueTwo = value
        return
      } else {
        this.calibrationParameterMetricRanges = [
          ...this.calibrationParameterMetricRanges,
          calibrationParameterMetricRange,
        ]
      }
    },

    setValueThree(value, rangeId, parameterId) {
      const calibrationParameterMetricRange = {
        CalibrationPatternMetricsRangeId: rangeId,
        CalibrationPatternTemplateParameterId: parameterId,
        ValueThree: value,
      }

      const parameterMetricRange = this.calibrationParameterMetricRanges.find(
        (x) =>
          x.CalibrationPatternMetricsRangeId === rangeId &&
          x.CalibrationPatternTemplateParameterId === parameterId
      )

      if (parameterMetricRange) {
        parameterMetricRange.ValueThree = value
        return
      } else {
        this.calibrationParameterMetricRanges = [
          ...this.calibrationParameterMetricRanges,
          calibrationParameterMetricRange,
        ]
      }
    },

    setValueFour(value, rangeId, parameterId) {
      const calibrationParameterMetricRange = {
        CalibrationPatternMetricsRangeId: rangeId,
        CalibrationPatternTemplateParameterId: parameterId,
        ValueFour: value,
      }

      const parameterMetricRange = this.calibrationParameterMetricRanges.find(
        (x) =>
          x.CalibrationPatternMetricsRangeId === rangeId &&
          x.CalibrationPatternTemplateParameterId === parameterId
      )

      if (parameterMetricRange) {
        parameterMetricRange.ValueFour = value
        return
      } else {
        this.calibrationParameterMetricRanges = [
          ...this.calibrationParameterMetricRanges,
          calibrationParameterMetricRange,
        ]
      }
    },

    setValueFive(value, rangeId, parameterId) {
      const calibrationParameterMetricRange = {
        CalibrationPatternMetricsRangeId: rangeId,
        CalibrationPatternTemplateParameterId: parameterId,
        ValueFive: value,
      }

      const parameterMetricRange = this.calibrationParameterMetricRanges.find(
        (x) =>
          x.CalibrationPatternMetricsRangeId === rangeId &&
          x.CalibrationPatternTemplateParameterId === parameterId
      )

      if (parameterMetricRange) {
        parameterMetricRange.ValueFive = value
        return
      } else {
        this.calibrationParameterMetricRanges = [
          ...this.calibrationParameterMetricRanges,
          calibrationParameterMetricRange,
        ]
      }
    },

    getMetricUnit(id) {
      if (this.calibrationMetrics.length > 0) {
        const find = this.calibrationMetrics.find((x) => x.id === id)
        if (find) {
          return find.name
        }
        return ''
      }
    },

    getCalibrationPatternName(id) {
      if (this.calibrationPatterns.length > 0) {
        return this.calibrationPatterns.find((x) => x.id === id).name
      }
    },

    async getCalibrationMetrics() {
      await this.apiService.get('calibrationMetrics/list').then((response) => {
        this.calibrationMetrics = response.content
      })
    },

    async getCalibrationPatterns() {
      await this.apiService.get('calibrationPattern/list').then((response) => {
        this.calibrationPatterns = response.content
      })
    },
  },
}
